import { useMemo } from 'react';

import { EmployeeExternalAccountType, EmployeeExternalAccountUserType } from '@/common/graphql';

interface Props {
  accountType: EmployeeExternalAccountType | null | undefined;
  className?: string;
  suffix?: string;
}

export const getExternalAccountName = (accountType: EmployeeExternalAccountType) => {
  switch (accountType) {
    case EmployeeExternalAccountType.Google:
      return 'Google';
    case EmployeeExternalAccountType.Greenhouse:
      return 'Greenhouse';
    case EmployeeExternalAccountType.Hubspot:
      return 'HubSpot';
    case EmployeeExternalAccountType.Slack:
      return 'Slack';
    case EmployeeExternalAccountType.Eloomi:
      return 'Eloomi';
    case EmployeeExternalAccountType.Github:
      return 'GitHub';
  }
};

export const ExternalAccountName = ({ accountType, className, suffix }: Props) => {
  const name = useMemo(() => {
    if (accountType) {
      return getExternalAccountName(accountType);
    } else {
      return '';
    }
  }, [accountType]);

  return (
    <span className={className}>
      {name}
      {suffix}
    </span>
  );
};

export const getExternalAccountUserTypeName = (userType: EmployeeExternalAccountUserType | null | undefined) => {
  switch (userType) {
    case EmployeeExternalAccountUserType.Member:
      return 'Member';
    case EmployeeExternalAccountUserType.GoogleSuperAdmin:
      return 'Super Admin';
    case EmployeeExternalAccountUserType.GoogleDelegatedAdmin:
      return 'Delegated Admin';
    case EmployeeExternalAccountUserType.SlackPrimaryOwner:
      return 'Primary Owner';
    case EmployeeExternalAccountUserType.SlackOwner:
      return 'Owner';
    case EmployeeExternalAccountUserType.SlackAdmin:
      return 'Admin';
    case EmployeeExternalAccountUserType.SlackMultiChannelGuest:
      return 'Multi-channel Guest';
    case EmployeeExternalAccountUserType.SlackSingleChannelGuest:
      return 'Single-channel Guest';
    case EmployeeExternalAccountUserType.EloomiAdmin:
      return 'Admin';
    case EmployeeExternalAccountUserType.HubspotSuperAdmin:
      return 'Super Admin';
    case EmployeeExternalAccountUserType.GreenhouseSiteAdmin:
      return 'Site Admin';
    case EmployeeExternalAccountUserType.GithubAdmin:
      return 'Admin';
    default:
      return null;
  }
};
